<template>
  <Textarea
    v-model:value="value"
    :placeholder="(($attrs.placeholder || $lang('请输入单号，多编号使用逗号、空格或回车键隔开，最多100个')) as string)"
    @blur="handleChange"
  ></Textarea>
</template>
<script lang="ts" setup>
  import { ref, watch } from 'vue'
  import { Textarea } from 'ant-design-vue'
  import { getSiteCodes } from '@/utils'

  const emit = defineEmits(['update:value'])
  const props = defineProps<{ value: string[] }>()
  const value = ref(props.value.join('\r'))
  watch(
    () => props.value,
    (c) => {
      value.value = c.join('\r')
    }
  )
  const handleChange = () => {
    emit('update:value', getSiteCodes(value.value))
  }
</script>
